import { ChatBubbleBottomCenterIcon, ChatBubbleOvalLeftEllipsisIcon, ChevronDoubleRightIcon, MapPinIcon, PaperAirplaneIcon, PhoneArrowDownLeftIcon } from "@heroicons/react/24/outline";

import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

import { Spinner } from "@material-tailwind/react";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Contact() {

    const [loading, setLoading] = React.useState(false);

    const form = useRef();

    const sendEmail = (e) => {

       if ( !form.current.first_name.value || !form.current.last_name.value || !form.current.email.value || !form.current.phone.value || !form.current.message.value ) {
              toast.error('Please fill all the fields!');
              
              form.current.first_name.value = '';
                form.current.last_name.value = '';
                form.current.email.value = '';
                form.current.phone.value = '';
                form.current.message.value = '';
                return;
         }
        

        setLoading(true);
      e.preventDefault();
  
      emailjs.sendForm('service_wpxbf6d', 'template_voauz8a', form.current, 'Tk1dNZB8jhi2mDy9v')
        .then((result) => {
            console.log(result.text);
            toast.success('Message sent successfully!');
            setLoading(false);
        }, (error) => {
            setLoading(false);
            toast.error('Message failed to send!');
            console.log(error.text);
        });
    };
    
    return (
        <div className="flex flex-col sm:flex-row gap-x-12 justify-center p-4 md:p-8 sm:flex-wrap">
            <div className="flex flex-col max-w-2xl sm:py-28 lg:py-15 rounded-md p-5">
                <p className="text-sm font-bold text-gray-900">Call Us</p>
                <p className="text-xs text-gray-600 mt-1">Call our team Monday to Friday 8am to 8pm</p>

                <div className="mt-6 flex gap-x-2">
                    <PhoneArrowDownLeftIcon className="h-4 w-4 text-gray-900 font-bold" />
                    <p
                        onClick={() => {
                            window.open('tel:+1-555-555-5555', '_blank');
                        }
                        }
                        className="text-xs text-gray-900 font-bold cursor-pointer hover:underline">
                        +1 (555) 555-5555</p>
                </div>

                <div className="mt-12 flex flex-col gap-x-2">
                    <p className="text-sm font-bold text-gray-900">Chat with us</p>
                    <p className="text-xs text-gray-600 mt-1">Chat with our friendly team via live chat</p>

                    <div className="mt-6 flex gap-x-2">
                        <ChatBubbleOvalLeftEllipsisIcon className="h-4 w-4 text-gray-900 font-bold" />
                        <p className="text-xs text-gray-900 font-bold">
                            Start a Live Chat</p>
                    </div>

                    <div className="mt-4 flex gap-x-2 cursor-pointer hover:underline" 
                    onClick={() => {
                        window.open('mailto:rana5542123@gmail.com', '_blank');
                    }
                    }>
                        <PaperAirplaneIcon className="h-4 w-4 text-gray-900 font-bold" />
                        <p className="text-xs text-gray-900 font-bold">
                            Shoot us an email</p>
                    </div>

                    <div className="mt-4 flex gap-x-2 cursor-pointer hover:underline"
                    onClick={() => {
                        window.open('https://www.linkedin.com/in/zaindev/', '_blank');
                    }
                    }>
                        <ChevronDoubleRightIcon className="h-4 w-4 text-gray-900 font-bold" />
                        <p className="text-xs text-gray-900 font-bold">
                            Message us on LinkedIn</p>
                    </div>
                </div>

                <p className="mt-10 text-sm font-bold text-gray-900">Vist Us</p>
                <p className="text-xs text-gray-600 mt-1">Visit our office at Islamabad Head Office</p>

                <div className="mt-6 flex gap-x-2">
                    <MapPinIcon className="h-4 w-4 text-gray-900 font-bold" />
                    <p className="text-xs text-gray-900 font-bold">
                        123 Street, Islamabad, Pakistan</p>
                </div>
            </div>

            <form className="flex flex-col max-w-2xl sm:py-28 lg:py-15 rounded-md p-5" ref={form}>
                <div className="flex flex-col sm:flex-row gap-x-4">
                    <div className="flex flex-col mt-4">
                        <label className="text-xs font-bold text-gray-700">First Name</label>
                        <input className="border border-gray-400 rounded-md p-2 mt-1 text-xs" type="text"
                        name="first_name"
                            placeholder="Enter your first name" />
                    </div>

                    <div className="flex flex-col mt-4">
                        <label className="text-xs font-bold text-gray-700">Last Name</label>
                        <input className="border border-gray-400 rounded-md p-2 mt-1 text-xs" type="text"
                        name="last_name"
                            placeholder="Enter your last name" />
                    </div>
                </div>

                <div className="flex flex-col mt-4">
                    <label className="text-xs font-bold text-gray-700">Email</label>
                    <input className="border border-gray-400 rounded-md p-2 mt-1 text-xs" type="text"
                        name="email"
                        placeholder="Enter your email" />
                </div>

                <div className="flex flex-col mt-4">
                    <label className="text-xs font-bold text-gray-700">Phone Number</label>
                    <input className="border border-gray-400 rounded-md p-2 mt-1 text-xs" type="text"
                        name="phone"
                        placeholder="Enter your phone number" />
                </div>

                <div className="flex flex-col mt-4">
                    <label className="text-xs font-bold text-gray-700">Message</label>
                    <textarea className="border border-gray-400 rounded-md p-2 mt-1 text-xs h-32" type="text"
                        name="message"
                        placeholder="Enter your message" />
                </div>

                <div className="flex flex-col mt-4">
                    <button
                        onClick={sendEmail}
                     className="bg-gray-900 text-white font-bold text-xs rounded-full p-2 mt-1 hover:bg-gray-800 cursor-pointer">
                        {loading ? 
                        <Spinner className="h-5 w-5 inline-block" color="white" />
                        : 'Send Message'}
                        </button>
                </div>
                <ToastContainer />
            </form>
        </div>
    )
}